module.exports = __webpack_public_path__ + "img/cloud-key.11c130a8.svg";